// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ck-emoji-grid-font-size{font-size:1.4em!important}", "",{"version":3,"sources":["webpack://./node_modules/@phudak/ckeditor5-emoji/theme/emoji-characters.css"],"names":[],"mappings":"AAAA,yBACI,yBACJ","sourcesContent":[".ck-emoji-grid-font-size {\r\n    font-size: 1.4em !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
